<template>
  <div>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div v-if="Object.keys(formConfig).length >= 1 && Object.keys(formConfig.field).length >= 1" class="servico-config-pco">
        <table>
          <tr>
            <td>
              Utilizar a seguinte Lista de Status para:
            </td>
            <td v-for="(campo, index) in formConfig.field" :key="index">
              <RF-Componente
                :data-time='time'
                :cpntTamanho='campo.tamanho'
                :cpntModelo='campo.tipo'
                :cpntStatus='campo.status'
                :cpntId='campo.id'
                :cpntClassDivField='campo.classDivField'
                :cpntNome='campo.nome'
                :cpntValue='campo.value'
                :cpntValueRef='campo.valueRef'
                :cpntOptions='campo.options'
                :cpntKeyValue='campo.keyValue'
                :cpntKeyMostra='campo.keyMostra'
                :cpntAutoComplete='campo.autocomplete'
                :cpntDisabled='campo.disabled'
                :cpntMostrar='campo.mostrar'
                :cpntMensagem='campo.mensagem'
                :cpntSelecioneNome='campo.selecioneNome'
                :cpntSelecioneValue='campo.selecioneValue'
                :cpntMensagemTipo='campo.mensagemTipo'
                :cpntAdicinarOption='campo.adicinarOption'
                :cpntMultiple='campo.multiple'
                :cpntAllRegistro='campo.allRegistro'
                :cpntExplica='campo.explica'
                :cpntTabIndex='campo.tabIndex'
                :cpntOptionInicialNome='campo.optionInicialNome'
                :cpntOptionInicialValue='campo.optionInicialValue'

                :cpntOnChange='campo.onChange'
                :cpntOnBlur='campo.onBlur'
                :ref='campo.tipo'
              ></RF-Componente>
            </td>
          </tr>
        </table>
      </div>
    </template>
  </div>
</template>

<style scoped>
.servico-config-pco {
  padding: 25px 0px 200px 0px;
}
  .servico-config-pco > table {
  }
    .servico-config-pco > table > tr > td {
      text-align: left;
    }
    .servico-config-pco > table > tr > td:not(:first-child) {
      padding: 0px 4px;
    }
    .servico-config-pco > table > tr > td:first-child {
      text-align: left;
      width: 240px;
    }
</style>

<style>
</style>

<script>
  export default {
    data: function () {
      return {
        time: '',
        statusGeral: '',
        finaliza: [],
        optionLista: [],
        formConfig: {}
      }
    },
    mounted: function () {
      this.servicoConfigPcoIniciar()
    },
    methods: {
      servicoConfigPcoAtualizarSessao: function (chaves, callback = null) {
        // VERIFICA SE DEVE CARREGAR AS CONFIGURAÇOES DE SESSAO
        if (chaves.length >= 1) {
          // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
          const SESSAO_ATUALIZAR_VUEX = require('@/assets/js/Sessao.js').SESSAO_ATUALIZAR_VUEX

          // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS DA API
          SESSAO_ATUALIZAR_VUEX(chaves, callback)
        } else if (callback !== null) {
          callback()
        }
      },
      servicoConfigPcoIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.servicoConfigPcoSetaStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
        this.servicoConfigPcoConfigIniciar()
      },
      servicoConfigPcoSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      servicoConfigPcoFinalizarCarregamento: function (funcao) {
        // SALVA A CONTAGEM DE FINALIZAÇÕES
        this.finaliza.push(funcao)

        // REMOVER VALORES DUPLICADOS
        this.finaliza = this.finaliza.filter((v, i, a) => a.indexOf(v) === i)

        if (this.finaliza.length === 1) {
          // SETA O STATUS DA TELA
          this.servicoConfigPcoSetaStatusGeral('')
        }
      },

      servicoConfigPcoConfigIniciar: function () {
        var self = this

        self.servicoConfigPcoBuscarListaStatus(function () {
          // INICIA O FORMULARIO DE CONFIGURAÇÕES
          self.formConfig = {
            field: {}
          }
          
          self.formConfig.field.categoria = {
            tipo: 'select2',
            status: '',
            tamanho: 3,
            id: 'servico-config-pco--categoria',
            nome: 'Serviço',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            value: self.$store.state.configuracoes.servico.cfg_id_pco_status,
            options: self.optionLista,
            optionsOriginal: [],
            optionInicialNome: 'Sem Padrão',
            explica: { mensagem: 'Este é apenas um padrão para a seleção automática ao criar um novo Serviço.' },
            onChange: self.servicoConfigPcoOnChagenConfig
          }
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // SETA QUE FOI FINALIZADO A FUNÇÃO
          self.servicoConfigPcoFinalizarCarregamento('servicoConfigPcoConfigIniciar')
        })
      },
      servicoConfigPcoBuscarListaStatus: function (callback = null, qtdeTotal = -1) {
        var self = this

        if (qtdeTotal === -1) {
          // LIMPA TODAS AS OPÇÕES EXISTENTES
          self.optionLista = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }

        if (qtdeTotal === -1 || self.optionLista.length < qtdeTotal) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: self.optionLista.length, qty: 1000 }, field: { id: null, nome: null, status: null }, where: { f: 'status', o: '=', v: '1' }, order: { nome: 'asc' } }

          // FAZ A BUSCA NA API
          self.$store.state.comunicaAPI('/con-processo/config/status/get/', 'GET', queryGet, function (apiSuccess) {
            // SETA OS VALORES RECEBIDOS
            self.optionLista = self.optionLista.concat(apiSuccess.data)
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR TODOS OS REGISTROS
            self.servicoConfigPcoBuscarListaStatus(callback, Number(apiSuccess.countAll))
          }, self.servicoConfigPcoSetaStatusGeral)
        } else if (callback !== null) {
          callback()
        }
      },
      servicoConfigPcoOnChagenConfig: function (value, id) {
        var self = this

        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // INICIA O FORMULARIO DA API
        var formData = { cfg_id_pco_status: value }

        // SETA QUAIS AS CHAVES DEVE ATUALIZAR NA SESSAO
        var chaves = []

        // SETA QUAL É A ROTA QUE DEVE UTILIZAR
        var router = ''
        switch (index) {
          case 'categoria':
            router = '/servico/config'
            chaves.push('config_servico')
            break
        }

        // COMUNICA COM A API
        self.$store.state.comunicaAPI(router, 'PUT', formData, function (apiSuccess) {
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            // RECARREGA AS SESSÕES NECESSARIAS
            self.servicoConfigPcoAtualizarSessao(chaves, self.servicoConfigPcoIniciar)
          })
        }, self.servicoConfigPcoSetaStatusGeral, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, 'formConfig', apiValid, apiStatus, self.formConfig.field, true, function (form, focus) {
            // SETA OS CAMPOS COM OS ERROS
            self.formConfig.field = form

            // SETA O CAMPO QUE RECEBE O FOCUS
            self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formConfig', focus, false)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        })
      }
    }
  }
</script>
